module.exports = __webpack_public_path__ + "media/images/pic/ramen1-0987d9380687c4491cb1dcf1b7ab40ea.png";